import { getLazyLinkToImage } from './getLazyLinkToImage';
const vNode = window.vNode;
const defaultWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1944, 2160, 2376, 2592, 2808, 3024];
export const lazyImageVNode = ({ url, additionalClass = '', styles, alt, widths = [], maxWidth, heightAttr, widthAttr, skeleton = false }) => {
    const imgLazySrc = getLazyLinkToImage(url);
    if (widths.length === 0 && maxWidth !== undefined) {
        widths = defaultWidths.filter((width) => {
            return width < maxWidth;
        });
        widths.push(maxWidth);
    }
    return vNode.create('img', {
        class: `lazyload${skeleton ? ' lazyskeleton' : ''} ${additionalClass}`,
        src: url,
        srcset: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
        alt: '',
        data: {
            src: imgLazySrc,
            sizes: 'auto'
        },
        loading: 'lazy',
        'data-widths': `[${widths.join(',')}]`,
        ...styles !== undefined && { style: styles },
        ...alt !== undefined && { alt },
        ...heightAttr !== undefined && { height: String(heightAttr) },
        ...widthAttr !== undefined && { width: String(widthAttr) }
    });
};
